import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Modal, Row } from "reactstrap";

const AboutUs = () => {

    return (
        <React.Fragment>
            <section className="section" id="about">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={12}>
                            <div className="heading-box text-center">
                                <h1 className="display-5 fw-normal fw-bold">
                                    About Us
                                </h1>
                                <p className="home-desc text-muted mt-4">
                                    Matrix Vision Technologies delivers practical and reliable automation solutions for industrial inspection and measurement challenges. We specialize in machine vision, image processing, and LabVIEW-based test systems that work reliably in real factory environments.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default AboutUs;